import React, { useState } from 'react';
import { Box, Container, Typography, Link, Divider, useTheme } from '@mui/material';
import TermsDialog from './TermsDialog';

const Footer = () => {
  const theme = useTheme();
  const [termsOpen, setTermsOpen] = useState(false);

  const handleTermsOpen = () => {
    setTermsOpen(true);
  };

  const handleTermsClose = () => {
    setTermsOpen(false);
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        mt: 4,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        position: 'relative',
        zIndex: 5
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            gap: { xs: 1, sm: 2 },
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          <Typography variant="body2" color="inherit">
            © {new Date().getFullYear()} Happy Hours TLV. All rights reserved.
          </Typography>
          
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
          
          <Link 
            href="https://www.happyhourstlv.com/privacy.html" 
            target="_blank"
            rel="noopener noreferrer" 
            color="inherit"
            underline="hover"
            sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
          >
            Privacy Policy
          </Link>
          
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
          
          <Link 
            component="button"
            color="inherit"
            underline="hover"
            onClick={handleTermsOpen}
            sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
          >
            Terms of Use
          </Link>
          
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)' }} />
          
        </Box>
      </Container>
      
      <TermsDialog open={termsOpen} onClose={handleTermsClose} />
    </Box>
  );
};

export default Footer;